import type React from 'react';
import { DISCOUNT_SCOPE } from '@/components/shortcuts';
import { DiscountDialogScope } from './DiscountDialogScope';
import { DiscountDialogView } from './DiscountDialogView';
import type { DiscountDialogState } from './useDiscountDialog';
import { useDiscountDialogKeys } from './useDiscountDialogKeys';

/**
 * The discount dialog's container: pushes `sellerDiscount` while open (the
 * sale screen's keys are suspended, `F1` still works), binds `Enter` to
 * Apply, and renders `DiscountDialogView`. The state is `useDiscountDialog`'s,
 * owned by the cart panel, which opens it from `F6` (a line) and `F7` (the
 * sale).
 */
export const DiscountDialog: React.FC<DiscountDialogState> = (dialog) => {
    useDiscountDialogKeys({ scope: DISCOUNT_SCOPE, onApply: dialog.apply });

    return (
        <>
            {dialog.isOpen ? <DiscountDialogScope /> : null}
            <DiscountDialogView {...dialog} />
        </>
    );
};
